namespace TabAurous.ECommerce {
    export namespace OrderMagentoImportAPIService {
        export const baseUrl = '~/api/Magento/Order';

        export declare function Create(request: OrderStatus, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "~/api/Magento/Order/Create"
        }

        [
            'Create'
        ].forEach(x => {
            (<any>OrderMagentoImportAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
